import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useSalesForDelivery } from '../../api/hooks/sales/useSalesForDelivery';
import { EntityPaginationData } from '../../components/molecules/EntityPaginationData';
import { SORT_BY_SALES, SORT_DIRECTION } from '../../interfaces/enumerables';
import { PATHS } from '../../navigation/data';
import { getSalesSortByFilter, getSalesTypeSelectionFilter } from '../../services/utils/sortData';
import { SaleForDeliveryItemCard } from '../Sales/components/SaleForDeliveryItemCard';
import { DeliveryInstructionsLink } from './component/DeliveryInstructionsLink';
import { DeliveryRetrieveDocByMark } from './component/DeliveryRetrieveDocByMark';

/**
 * @deprecated
 * This is probably going to be removed to avoid confusion of users
 * They can apply the same step from `SaleScreen`
 */
export const NewDeliveryScreen = () => {
  const navigate = useNavigate();
  const handleSearch = useCallback(
    (mark: string) => navigate(`${PATHS.DELIVERIES}/register-transfer/${mark}`),
    [navigate],
  );

  const salesSortByFilter = useMemo(() => getSalesSortByFilter(), []);
  const salesTypeFilter = useMemo(() => getSalesTypeSelectionFilter(), []);

  const getList = useCallback(() => {
    return (
      <EntityPaginationData
        useDataHook={useSalesForDelivery}
        ItemCardData={SaleForDeliveryItemCard}
        sortByFilter={salesSortByFilter}
        sortByDefaultKey={SORT_BY_SALES.SENT_TO_AADE_AT}
        sortDirectionValue={SORT_DIRECTION.DESC}
        typeFilter={salesTypeFilter}
        hideCreateButton
        hideSearchButton
        hideFiltersSection
        headerClass="entity-pagination-wrapper-delivery-by-mark"
      />
    );
  }, [salesSortByFilter, salesTypeFilter]);

  return (
    <div className="width-100 padding-16 flex-start-center-column-nowrap">
      <DeliveryInstructionsLink />
      <div className="flex-start-center-column-nowrap">
        <DeliveryRetrieveDocByMark onSearch={handleSearch} />
      </div>
      {getList()}
    </div>
  );
};
